import React, {Fragment} from 'react';
import Overlay from 'Components/Overlay';
import Input from 'Components/Input';
import Dropdown from 'Components/Dropdown';
import Checkbox from 'Components/Checkbox';
import Cx from 'classnames';

const Tk11Popup = (props)=>(
    <Fragment>
        <Overlay>
            <div className="bg-white box-shadow ph-20 pv-20 br-5">
                <div className="mb-30 tCenter header-medium-color fSemibold fs-18">
                    {props.text}
                </div>
                {(props.response || []).map((res, index) => {
                    return (
                        <Fragment>
                        {(index === 0) && <div className="flex flex-between">
                            <div className="mb-10 wt-25 mr-10 header-medium-color fSemibold fs-14">  </div>
                            <div className="mb-10 wt-200 mr-10 header-medium-color fSemibold fs-14"> Route Code </div>
                            <div className="mb-10 wt-200 mr-10 header-medium-color fSemibold fs-14"> Transporter Code </div>
                            <div className="mb-10 wt-200 mr-10 header-medium-color fSemibold fs-14"> Sub Plants </div>
                            <div className="mb-10 wt-200 mr-10 header-medium-color fSemibold fs-14"> Reason </div>
                        </div>}
                        {res.resCode === 'E' && <div className="flex mb-10 header-medium-color fSemibold fs-14">
                            <div className="pb-10 mt--1 mr-10 wt-25 pt-15">
                            <Checkbox
                                type="square"
                                // checked={this.props.selectedBids.filter((bid) => {
                                //     return bid.orderText === trip.bids[i].orderText
                                // }).length >= mtrip.subTrips.filter((trp) => {
                                //     return (trp.bids || []).length > i
                                // }).length}
                                checked={props.tk11SelctedPlant && props.tk11SelctedPlant.indexOf(res.planningPoint) > -1}
                                onCheck={() => props.SelectPlanningPoint(res.planningPoint)}
                            />
                            </div>
                            <div className="pb-10 mt--1 mr-10">
                                <Input className="wt-200" name="routeCode" value={res.routeCode} onChange={(e) => props.onRouteCodeChange(e, index)}  readOnly={true} />
                            </div>
                            <div className="pb-10 mt--1 mr-10">
                                <Input className="wt-200" name="transporterCode" value={res.transporterCode} onChange={(e) => props.onTransporterCodeChange(e, index)}  readOnly={true} />
                            </div>
                            <div className="header-medium-color fSemibold fs-14 mr-10">
                                {/* <Input className="wt-200" name="planningPoint" readOnly={true} value={res.planningPoint} onChange={(e) => props.onTransporterCodeChange(e, index)} /> */}
                                <Dropdown
                                    className="wt-200"
                                    items={props.subPlants || []} 
                                    selectedItem={(props.subPlants || []).find(subPlant=>{return (res && res.planningPoint ? res.planningPoint : '') === subPlant.transport_planning_point})} 
                                    displayKey="transport_planning_point" 
                                    name="subPlants" 
                                    label="Select unit" 
                                    onSelect={(item) => props.onSelect(item, index)}
                                />
                            </div>
                            <div className="pb-10 mt--1 wt-200 error-color pt-15 tCenter ht-40">
                               { res.errorMessage }
                            </div>
                        </div>}
                        </Fragment>
                    )
                })}
                <div className="col-1 ht-60 flex flex-middle flex-center bg-white">
                    <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={props.onCancel}>Cancel</button>
                    <button className={ Cx("ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30", {
                        'notselectable': props.tk11SelctedPlant.length === 0
                    })} onClick={props.onConfirm}>Confirm</button>
                </div>
            </div>    
        </Overlay> 
    </Fragment>
    
);

export default Tk11Popup;